import { useSelector } from 'react-redux';

import { usePdfRenderedTelemetry } from '@makemydeal/dr-shared-ui-utils/pdfRenderTelemetry/usePdfRenderedTelemetry';

import { getDealPdfVersion } from '../store/selectors';

export const DEAL_SUMMARY_PDF_RENDERED_PAGE_ACTION = 'SC:DealSummaryPdfRendered';

export type DealSummaryPdfView = 'viewQuote' | 'acceptedDeal';

export const useDealSummaryPdfRenderedTelemetry = (pdfUrl: string | undefined, view: DealSummaryPdfView): (() => void) => {
    const dealPdfVersion = useSelector(getDealPdfVersion);

    return usePdfRenderedTelemetry({
        pageActionName: DEAL_SUMMARY_PDF_RENDERED_PAGE_ACTION,
        pdfUrl,
        dedupeScope: view,
        attributes: { dealPdfVersion, view }
    });
};
